import React from 'react';

interface ResumoSelecaoProps {
  selecionados: number;
  total: number;
  totalFiltrados: number;
  totalUsinas: number;
  totalPotenciaMw: number;
}

function formatarInt(valor: number): string {
  return valor.toLocaleString('pt-BR');
}

function formatarMw(valor: number): string {
  return valor.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Footer do modal SeletorConjuntos — fonte unica de contadores.
 *
 * FE-LAYOUT-007 #3: antes existiam dois lugares mostrando informacao
 * correlata — "X resultados" no topo (ChipsFiltrosAtivos) e "X de N
 * selecionados" no rodape. Foi unificado aqui:
 *   - filtro ativo: "N resultados · X selecionados · Y usinas · Z MW"
 *   - sem filtro:   "X de N selecionados · Y usinas · Z MW"
 *
 * A linha secundaria com usinas/MW continua porque "selecionei 2
 * conjuntos" oculta o impacto real ("50 usinas inclusas") — informacao
 * util pra escolher entre conjuntos antes de aplicar.
 */
export default function ResumoSelecao({
  selecionados,
  total,
  totalFiltrados,
  totalUsinas,
  totalPotenciaMw,
}: ResumoSelecaoProps) {
  const filtroAtivo = totalFiltrados < total;
  return (
    <div className="windx-seletor-conjuntos__resumo" aria-live="polite">
      <span className="windx-seletor-conjuntos__resumo-principal">
        {filtroAtivo ? (
          <>
            <span className="windx-seletor-conjuntos__resumo-resultados">
              {formatarInt(totalFiltrados)}
              {totalFiltrados === 1 ? ' resultado' : ' resultados'}
            </span>
            <span aria-hidden="true">{' · '}</span>
            <strong className="windx-seletor-conjuntos__resumo-contador">
              {formatarInt(selecionados)}
              {selecionados === 1 ? ' selecionado' : ' selecionados'}
            </strong>
          </>
        ) : (
          <strong className="windx-seletor-conjuntos__resumo-contador">
            {formatarInt(selecionados)}
            {' de '}
            {formatarInt(total)}
            {' conjuntos selecionados'}
          </strong>
        )}
      </span>
      <span className="windx-seletor-conjuntos__resumo-detalhe">
        {formatarInt(totalUsinas)}
        {' usina'}
        {totalUsinas === 1 ? '' : 's'}
        {' inclusa'}
        {totalUsinas === 1 ? '' : 's'}
        {' · '}
        {formatarMw(totalPotenciaMw)}
        {' MW'}
      </span>
    </div>
  );
}
